<template>
  <button
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "GuestButton",
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
button {
  display: grid;
  place-items: center;
  width: 45px !important;
  height: 40px;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  background: none;
  border: none;
  padding: 0;  
  user-select: none;
  cursor: pointer;
  &.selected span {
    background: var(--blueGradient);
  } 
  span {
    transition: 0.2s all ease-in-out;
    width: 40px;
    height: 20px;
    display: grid;
    place-items: center;
    background: var(--dark-blue);
    padding: 5px;
    color: var(--white);
    line-height: 1rem;
    font-family: 'Sharp Grotesk';    
  }
   @media (hover: hover) {
    &:hover {
      span {
        background: var(--darker-blue);
      }
    }
  }
}
</style>